import { styled } from "@mui/material/styles";

const StyledCustomerSupport = styled("div")(({ theme }) => `
  .main-container {
    padding: 0 15%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  .header {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-top: 20px;
    align-self: flex-start;
  }

  .header-title {
    font-family: 'Lexend', sans-serif;
    font-weight: 400;
    font-size: 24px;
    line-height: 100%;
    color: ${theme.palette.primary.main};
  }

  .title-box {
    width: 100%;
    background-color: ${theme.palette.customColor.white};
    padding-top: 63px;
    @media (max-width: 850px) {
      padding-top: 32px;
    }
    @media (max-width: 600px) {
      padding-top: 23px;
    }
  }

  .main-title {
    font-family: 'Lexend', sans-serif;
    font-weight: 400;
    font-size: 32px;
    line-height: 40px;
    color: ${theme.palette.primary.main};
    text-align: center;
    margin-bottom: 16px;
    @media (max-width: 600px) {
      font-size: 18px;
      line-height: 22.5px;
    }
  }

  .search-box {
  }

  .search-container {
    display: flex;
    align-items: center;
    border: 0.8px solid ${theme.palette.customColor.secondaryThird};
    padding: 9px 14px;
    width: 97%;
  }

  .search-container:focus-within {
    border-color: ${theme.palette.primary.main};
  }

  .search-icon {
    width: 20px;
    height: 20px;
    margin-right: 12px;
  }

  .input-text {
    font-family: 'Lexend', sans-serif;
    font-weight: 400;
    font-size: 14px;
    line-height: 17.5px;
    color: ${theme.palette.customColor.placeholder};
  }

  .MuiInputBase-input:focus {
    color: ${theme.palette.primary.main} !important;
  }

  .MuiInputBase-input {
    font-family: 'Lexend', sans-serif;
  }

  .info-container {
    width: 100%;
  }

  .info-box {
    display: flex;
    align-items: center;
    border: 0.8px solid ${theme.palette.customColor.secondaryThird};
    padding: 4px 16px;
    width: 100%;
    height: 60px;
    transition: border-color 0.3s ease-in-out;
    margin-top: 32px;
    @media (max-width: 600px) {
      margin-top: 24px;
    }
  }

  .icon {
    width: 24px;
    height: 24px;
    margin-right: 8px;
  }

  .text-container {
    display: flex;
    flex-direction: column;
    margin-left: 8px;
  }

  .title {
    font-family: 'Lexend', sans-serif;
    font-weight: 400;
    font-size: 14px;
    line-height: 17.5px;
    color: ${theme.palette.primary.main};
  }

  .subtitle {
    font-family: 'Lexend', sans-serif;
    font-weight: 400;
    font-size: 12px;
    line-height: 15px;
    color: ${theme.palette.customColor.secondarySecond};
    margin-top: 4px;
  }

  .FAQ-container {
  }

  .FAQ-content {
    margin-top: 32px;
  }

  .FAQ-title {
    font-family: 'Lexend', sans-serif;
    font-weight: 400;
    font-size: 20px;
    line-height: 25px;
    color: ${theme.palette.primary.main};
  }

  .FAQ-subtitle {
    font-family: 'Lexend', sans-serif;
    font-weight: 400;
    font-size: 14px;
    line-height: 17.5px;
    color: ${theme.palette.customColor.secondarySecond};
    margin-top: 4px;
  }

  .FAQ-box {
    font-family: 'Lexend', sans-serif;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    margin-top: 16px;
  }

  @media (min-width: 768px) {
    .FAQ-box {
      flex-direction: row;
    }
  }

  .FAQ-content-1 {
    display: flex;
    flex-direction: column;
    gap: 12px;
    width: 100%;
  }

  .FAQ-box-1 {
    background-color: #f6f4f1;
    box-shadow: none;
    padding-top: 7.5px;
    padding-bottom: 7.5px;
  }

  .FAQ-box-1::before {
    display: none;
  }

  .IconRemove {
    padding: 0px;
  }

  .FAQ-main-title {
    font-size: 18px;
    line-height: 20px;
    font-family: 'Lexend', sans-serif;
    font-weight: 400;
    color: ${theme.palette.primary.main};
  }

  .FAQ-main-subtitle {
    font-size: 14px;
    line-height: 22px;
    font-family: 'Lexend', sans-serif;
    font-weight: 400;
    color: ${theme.palette.customColor.secondarySecond};
  }

  .MuiAccordionDetails-root {
    padding: 8px 23px 16px;
    @media (max-width: 600px) {
      padding: 8px 16px 16px;
    }
  }

  .contact-container {
    margin-top: 20px;
    bottom: 0;
    width: 100%;
    background-color: ${theme.palette.customColor.white};
    text-align: center;
    padding: 10px 0;
  }

  .contact-box {
    padding-left: 88px;
    padding-right: 88px;
    padding-bottom: 42px;
    @media (max-width: 850px) {
      padding-left: 48px;
      padding-right: 48px;
    }
    @media (max-width: 600px) {
      padding-left: 16px;
      padding-right: 16px;
    }
  }

  .contact-title {
    font-size: 20px;
    line-height: 25px;
    font-family: 'Lexend', sans-serif;
    font-weight: 400;
    color: ${theme.palette.primary.main};
    @media (max-width: 600px) {
      font-size: 16px;
      line-height: 20px;
    }
  }

  .contact-content {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 54px;
    border-top: 1px solid ${theme.palette.customColor.secondaryThird};
    border-bottom: 1px solid ${theme.palette.customColor.secondaryThird};
    padding: 15px 0;
    margin-top: 16px;
  }

  .contact-subtitle,
  .Mail-box {
    text-decoration: none;
    color: inherit;
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .line {
    height: 28px;
    width: 1px;
    background-color: ${theme.palette.customColor.secondaryThird};
  }

  .PhoneIcon,
  .EmailIcon {
    width: 24px;
    height: 24px;
  }

  .phone-title,
  .Email-title {
    font-size: 16px;
    line-height: 20px;
    font-family: 'Lexend', sans-serif;
    font-weight: 400;
    color: ${theme.palette.primary.main};
  }

  .para {
    font-size: 14px;
    line-height: 17.5px;
    font-family: 'Lexend', sans-serif;
    font-weight: 400;
    color: ${theme.palette.customColor.secondarySecond};
    margin-top: 12px;
    @media (max-width: 600px) {
      font-size: 12px;
      line-height: 15px;
    }
  }
`);

export default StyledCustomerSupport;
